<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("empresasPessoas") }}
        </h1>
      </div>
    </div>
    <EmpresasTable />
  </div>
</template>

<script>
import EmpresasTable from './components/EmpresasTable.vue';

export default {
  components: { EmpresasTable },
};
</script>
